/* Fixed so every phase and A/B variant opens at the same size. */
.dialog {
  height: 720px;
  width: 600px;
}

.header {
  padding: 16px 24px;
}

.titleRow {
  align-items: center;
  display: grid;
  grid-template-columns: 48px 1fr 48px;
}

.back {
  grid-column: 1;
  justify-self: start;
}

.title {
  grid-column: 2;
}

.close {
  grid-column: 3;
  justify-self: end;
}

.footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;

  @media (--reefer-media-tablet-max) {
    flex-direction: column;

    & > * {
      width: 100%;
    }
  }
}

/* Header and footer stay put while the body scrolls inside the sheet. */
.sheet {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.sheetBody {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
}

.sheetFooter {
  box-shadow: var(--shadows-divider-top);
  padding: 16px 24px;
}
